import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state={
    payStatus:{//账单状态
        nonPaid:'1',//待支付
        paid:'2',
        overdue:'3'//已逾期
     },
     month:{
        1:'January',    
        2:'February',            
        3:'March',            
        4:'April',            
        5:'May',            
        6:'June',            
        7:'July',            
        8:'August',            
        9:'September',            
        10:'October',            
        11:'November',           
        12:'December', 
     },
     billInfoFlag:0,//1当前账单页，2代表账单详情页跳转到支付页
}

const mutations={
    SET_FLAG:(state,data)=>{
        state.billInfoFlag=data
    }
}
const actions={}
const modules={}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    modules,
})




// WEBPACK FOOTER //
// ./src/store/index.js